module.exports = __webpack_public_path__ + "static/img/warPer.ecea2ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warPer.png
// module id = svqs
// module chunks = 208